import { commonUtils } from '@/helpers/commonUtils'
import { Popover } from 'antd'
import styles from './PricingCard.module.less'
import { AIModel, ComparisonFeature, PlanType, PricingCardProps } from './types'

// AI模型数据
const topTierModels: AIModel[] = []

const advancedModels: AIModel[] = []

const basicModels: AIModel[] = []

export const MaxConstData = {
  UltraModelToken: '不可用',
  maxModelToken: 1500,
  maxModelTokenUnit: '万/月',
  pdfProPageCount: 750,
  pdfProPageUnit: '页/月',
  pdfProMaxPage: 500,
  pdfProMaxFileSize: 100,
  pdfUltraPageCount: 5000,
  pdfUltraPageUnit: '页/月',
  pdfUltraMaxPage: 500,
  pdfUltraMaxFileSize: 100,
  wordMaxFileSize: 50,
  wordMaxFileSizeUnit: 'M',
  pictureCount: 750,
  pictureUnit: '张/月',
  fileRetentionMonth: 1,
  fileRetentionMonthsUnit: '个月',
  fileParseSpeed: 10,
  fileParseSpeedUnit: '页/分钟',
}

export const UltraConstData = {
  UltraModelToken: 150,
  UltraModelTokenUnit: '万/月',
  maxModelToken: 3750,
  maxModelTokenUnit: '万/月',
  pdfProPageCount: 2250,
  pdfProPageUnit: '页/月',
  pdfProMaxPage: 1500,
  pdfProMaxFileSize: 300,
  pdfUltraPageCount: 15000,
  pdfUltraPageUnit: '页/月',
  pdfUltraMaxPage: 1500,
  pdfUltraMaxFileSize: 300,
  wordMaxFileSize: 300,
  wordMaxFileSizeUnit: 'M',
  pictureCount: 1500,
  pictureUnit: '张/月',
  fileRetentionMonth: 6,
  fileRetentionMonthsUnit: '个月',
  fileParseSpeed: 20,
  fileParseSpeedUnit: '页/分钟',
}

const renderGroupIcon = (type: 'speed' | 'quality', count: number) => {
  const speedIcon = commonUtils.getStaticFile('icon__speed.svg')
  const qualityIcon = commonUtils.getStaticFile('icon__quality.svg')
  const speedIconGray = commonUtils.getStaticFile('icon__speed-gray.svg')
  const qualityIconGray = commonUtils.getStaticFile('icon__quality-gray.svg')
  const icons = []
  let i = 0
  const maxCount = 6
  while (i < maxCount) {
    if (i < count) {
      icons.push(type === 'speed' ? speedIcon : qualityIcon)
    } else {
      icons.push(type === 'speed' ? speedIconGray : qualityIconGray)
    }
    i++
  }
  return (
    <>
      {icons.map((icon, index) => {
        return <img key={index} src={icon} className={styles.compareIcon} />
      })}
    </>
  )
}

// Ultra版配置
export const ultraPlanConfig: PricingCardProps = {
  planType: 'ultra',
  recommended: true,
  init: false,
  header: {
    planType: 'ultra',
    title: 'Ultra 会员',
    icon: 'price_ultra.png',
    monthlyPrice: '0',
    annualMonthlyPrice: '34.3',
    annualPrice: '294',
    originalAnnualPrice: '468',
    discountPercent: 37,
    showAnnualToggle: true,
    isAnnualSubscription: false,
    onAnnualToggle: (isAnnual) => console.log('Annual toggle:', isAnnual),
  },
  modelSection: {
    planType: 'ultra',
    tokenQuotas: [
      {
        title: (
          <>
            每月
            <span className={styles.highlightUltra}>
              {' '}
              {UltraConstData.UltraModelToken.toLocaleString()}{' '}
            </span>
            万顶级模型 Token
            <Popover
              content={
                <div style={{ maxWidth: '320px' }}>
                  <p>
                    {UltraConstData.UltraModelToken.toLocaleString()} 万 Token
                    大约可以处理的翻译任务数量：
                  </p>
                  <p>20 篇中篇小说翻译，</p>
                  <p>或 3,00 页 PDF 文档翻译（论文类型），</p>
                  <p>或 5,00 个常见网页的对照翻译，</p>
                  <p>或 50,00 次的划词翻译</p>
                  <p>注：实际可处理任务数量取决于任务中包含的文本字数，可能大于或小于以上数量</p>
                </div>
              }
              placement='top'
              getPopupContainer={(el) => el.parentElement!}
            >
              <img
                className={styles.warningIcon}
                src={commonUtils.getStaticFile('common/icon__warning.png')}
              />
            </Popover>
          </>
        ),
        description:
          '使用由顶级模型驱动的翻译功能。对高复杂度的文本进行处理以及进行更深度的语义理解，适合专业级的翻译场景使用',
        monthlyQuota: '200W',
        models: topTierModels,
      },
      {
        title: (
          <>
            每月
            <span className={styles.highlightUltra}>
              {' '}
              {UltraConstData.maxModelToken.toLocaleString()}{' '}
            </span>
            万高级模型 Token
            <Popover
              content={
                <div style={{ maxWidth: '320px' }}>
                  <p>
                    {UltraConstData.maxModelToken.toLocaleString()} 万 Token
                    大约可以处理的翻译任务数量：
                  </p>
                  <p>500 篇中篇小说翻译，</p>
                  <p>或 7,500 页 PDF 文档翻译（论文类型），</p>
                  <p>或 12,500 个常见网页的对照翻译，</p>
                  <p>或 125,000 次的划词翻译</p>
                  <p>注：实际可处理任务数量取决于任务中包含的文本字数，可能大于或小于以上数量</p>
                </div>
              }
              placement='top'
              getPopupContainer={(el) => el.parentElement!}
            >
              <img
                className={styles.warningIcon}
                src={commonUtils.getStaticFile('common/icon__warning.png')}
              />
            </Popover>
          </>
        ),
        description: '使用由高级模型驱动的翻译、总结、解释、Chat 功能。翻译更精准，使用更丝滑。',
        monthlyQuota: '5000W',
        models: advancedModels,
      },
    ],
  },
  featureList: {
    title: 'Ultra 会员专属 (包含所有Max会员权益)',
    planType: 'ultra',
    planDesc: (
      <>
        <span>顶级模型、顶级额度、顶级权益、顶级体验！</span>
        <br />
        <span>
          适用有专业翻译需求或高频使用的用户{' '}
          <Popover
            content={
              <div style={{ maxWidth: '320px' }}>
                <p>
                  Ultra 会员拥有一系列
                  <strong>更多、更大、更快、更稳定</strong>
                  的权益特性。如果你符合以下条件，建议购买 Ultra
                  会员，以获取更匹配需要的使用体验。否则建议购买 Max 会员
                </p>
                <p>
                  <strong>1、我的日常工作/学习中每天都需要使用到网页翻译功能</strong>
                  ，例如电商从业者。Ultra 会员有数倍多 Max
                  会员的高级模型额度，能充分的满足高频、深度的翻译功能的使用
                </p>
                <p>
                  <strong>2、我需要更专业的翻译结果</strong>
                  ，例如医疗和生物科技领域、工程和技术领域、金融和商业领域从业者。Ultra
                  会员可以选用专属的顶级 AI 模型，更适合专业级的翻译场景使用
                </p>
                <p>
                  <strong>3、我日常有大量的文件翻译需求</strong>
                  ，例如金融、律师、翻译行业从业者。Ultra 会员有数倍多 Max 会员的 PDF
                  解析页数，以及支持上传更多的术语表条数，能更好的满足大量文件翻译的使用场景
                </p>
                <p>
                  <strong>4、我是企业用户</strong>
                  。Ultra 会员支持同时登录 6 台设备，能更好的满足企业员工账号共享的使用场景
                </p>
                <p>
                  <strong>5、我是个人用户，但我的经济条件允许</strong>
                  。我希望能获得更好的使用体验，价格对我来说不是最重要的考量因素
                </p>
              </div>
            }
            placement='top'
            getPopupContainer={(el) => el.parentElement!}
          >
            <img
              className={styles.warningIcon}
              src={commonUtils.getStaticFile('common/icon__warning.png')}
            />
          </Popover>
        </span>
      </>
    ),
    planCompare: (
      <>
        <div className={styles.planCompareItem}>
          <span className={styles.label}>翻译质量</span>
          <div className={styles.iconList}>{renderGroupIcon('quality', 8)}</div>
        </div>
        <div className={styles.planCompareItem}>
          <span className={styles.label}>翻译速度</span>
          <div className={styles.iconList}>{renderGroupIcon('speed', 8)}</div>
        </div>
      </>
    ),
    features: [
      // 顶级模型 Token
      {
        name: (
          <>
            <p>顶级模型 Token</p>
            <Popover
              content={
                <div style={{ maxWidth: '320px' }}>
                  <p>顶级模型包括 Claude 4 Sonnet、GPT-5、Gemini 2.5 Pro</p>
                </div>
              }
            >
              <img
                className={styles.warningIcon}
                src={commonUtils.getStaticFile('common/icon__warning.png')}
              />
            </Popover>
          </>
        ),
        description: (
          <>
            <span className={styles.highlightUltra}>
              {' '}
              {UltraConstData.UltraModelToken.toLocaleString()} 万/月
            </span>
          </>
        ),
      },
      // 高级模型 Token
      {
        name: (
          <>
            <p>高级模型 Token</p>
            <Popover
              content={
                <div style={{ maxWidth: '320px' }}>
                  <p>
                    高级模型包括 DeepL、DeepSeek
                    V3、Doubao-Seed-1.6、Qwen-3-Plus、智谱GLM-4.5、GPT-5 mini、Claude 3.5
                    Haiku、Gemini 2.5 Flash
                  </p>
                </div>
              }
            >
              <img
                className={styles.warningIcon}
                src={commonUtils.getStaticFile('common/icon__warning.png')}
              />
            </Popover>
          </>
        ),
        description: (
          <>
            <span className={styles.highlightUltra}>
              {' '}
              {UltraConstData.maxModelToken.toLocaleString()} 万/月
            </span>
          </>
        ),
      },
      // 核心翻译功能
      {
        name: (
          <>
            <p>核心翻译功能</p>
            <Popover
              content={
                <div style={{ maxWidth: '320px' }}>
                  <p>
                    核心翻译功能包括：网页译文翻译、网页对照翻译、划词翻译、悬停翻译、视频翻译、即时翻译
                  </p>
                </div>
              }
              placement='right'
              getPopupContainer={(el) => el.parentElement!}
            >
              <img
                className={styles.warningIcon}
                src={commonUtils.getStaticFile('common/icon__warning.png')}
              />
            </Popover>
          </>
        ),
        description: (
          <>
            <p style={{ textAlign: 'right' }}> 不限次数 </p>
            <p>
              <span className={styles.highlightUltra}>顶级模型</span>/高级模型/基础模型
            </p>
          </>
        ),
      },
      // PDF 分段翻译
      {
        name: (
          <>
            <a
              className={styles.underlineLink}
              href='https://lenovo.huiyiai.net/pdf_pro'
              target='__blank'
            >
              PDF 分段翻译
            </a>
            <Popover
              content={
                <div style={{ maxWidth: '320px' }}>
                  <p>由 AI 驱动的 PDF 分段翻译</p>
                  <p>支持扫描版 PDF。提供上下对照的分段翻译效果，更利于阅读</p>
                  <p>适用于科研论文、技术文档等专业性较强文档的查阅场景</p>
                </div>
              }
              placement='right'
              getPopupContainer={(el) => el.parentElement!}
            >
              <img
                className={styles.warningIcon}
                src={commonUtils.getStaticFile('common/icon__warning.png')}
              />
            </Popover>
          </>
        ),
        description: (
          <>
            <p style={{ textAlign: 'right' }}>
              <span className={styles.highlightUltra}>
                {UltraConstData.pdfProPageCount.toLocaleString()} 页/月
              </span>
            </p>
            <p>
              单个文件最大
              <span className={styles.highlightUltra}>
                {UltraConstData.pdfProMaxPage.toLocaleString()} 页/
                {UltraConstData.pdfProMaxFileSize.toLocaleString()}M
              </span>
            </p>
          </>
        ),
      },
      // PDF 无损翻译
      // {
      //   name: (
      //     <>
      //       <a
      //         className={styles.underlineLink}
      //         href='https://lenovo.huiyiai.net/pdf_ultra'
      //         target='__blank'
      //       >
      //         PDF 无损翻译
      //       </a>
      //       <Popover
      //         content={
      //           <div style={{ maxWidth: '320px' }}>
      //             <p>由 AI 驱动的 PDF 无损翻译</p>
      //             <p>暂不支持扫描版 PDF。提供 1:1 保留原版式的翻译效果</p>
      //             <p>适用于公司介绍、产品说明书等对版式还原要求较高的翻译场景</p>
      //           </div>
      //         }
      //         placement='right'
      //         getPopupContainer={(el) => el.parentElement!}
      //       >
      //         <img
      //           className={styles.warningIcon}
      //           src={commonUtils.getStaticFile('common/icon__warning.png')}
      //         />
      //       </Popover>
      //     </>
      //   ),
      //   description: (
      //     <>
      //       <p style={{ textAlign: 'right' }}>
      //         <span className={styles.highlightUltra}>15,000 页/月</span>
      //       </p>
      //       <p>
      //         单个文件最大<span className={styles.highlightUltra}> 1,500 页/300M</span>
      //       </p>
      //     </>
      //   ),
      // },
      // Word 翻译
      // {
      //   name: (
      //     <>
      //       <a className={styles.underlineLink} href='https://lenovo.huiyiai.net/word' target='__blank'>
      //         Word 翻译
      //       </a>
      //       <Popover
      //         content={
      //           <div style={{ maxWidth: '320px' }}>
      //             <p>由 AI 驱动的 Word 翻译</p>
      //             <p>上传待翻译的 Word 文件，翻译完成后自动下载到本地</p>
      //           </div>
      //         }
      //         placement='right'
      //         getPopupContainer={(el) => el.parentElement!}
      //       >
      //         <img
      //           className={styles.warningIcon}
      //           src={commonUtils.getStaticFile('common/icon__warning.png')}
      //         />
      //       </Popover>
      //     </>
      //   ),
      //   description: (
      //     <>
      //       <p style={{ textAlign: 'right' }}>
      //         <span className={styles.highlightUltra}>不限页数</span>
      //       </p>
      //       <p>
      //         单个文件最大<span className={styles.highlightUltra}> 300M </span>
      //       </p>
      //     </>
      //   ),
      // },
      // 自定义术语表
      // {
      //   name: (
      //     <>
      //       <a
      //         className={styles.underlineLink}
      //         href='https://lenovo.huiyiai.net/dashboard/glossary'
      //         target='__blank'
      //       >
      //         自定义术语表
      //       </a>
      //       <Popover
      //         content={
      //           <div style={{ maxWidth: '320px' }}>
      //             <p>
      //               已支持在 PDF 分段翻译、PDF 无损翻译、Word
      //               翻译、网页对照翻译、划词翻译、悬停翻译、文本翻译、视频翻译中应用术语
      //             </p>
      //           </div>
      //         }
      //         placement='right'
      //         getPopupContainer={(el) => el.parentElement!}
      //       >
      //         <img
      //           className={styles.warningIcon}
      //           src={commonUtils.getStaticFile('common/icon__warning.png')}
      //         />
      //       </Popover>
      //     </>
      //   ),
      //   description: (
      //     <>
      //       <p style={{ textAlign: 'right' }}>
      //         <span className={styles.highlightUltra}>10,000 </span>条自定义术语
      //       </p>
      //       <p>Trados 术语库｜多设备同步</p>
      //     </>
      //   ),
      // },
      // 网页生词高亮
      {
        name: (
          <>
            <a
              className={styles.underlineLink}
              href='https://lenovo.huiyiai.net/learning?tab=unlearned'
              target='__blank'
            >
              网页生词高亮
            </a>
            <Popover
              content={
                <div style={{ maxWidth: '260px' }}>
                  <p>根据配置的词库，自动识别并高亮网页中的生词及释义，把网页变成“课堂”</p>
                </div>
              }
              placement='right'
              getPopupContainer={(el) => el.parentElement!}
            >
              <img
                className={styles.warningIcon}
                src={commonUtils.getStaticFile('common/icon__warning.png')}
              />
            </Popover>
          </>
        ),
        description: '无限制使用',
      },
      // 图片翻译
      {
        name: '图片翻译',
        description: `${UltraConstData.pictureCount.toLocaleString()} 张/月`,
      },
      // 自动检测术语
      // {
      //   name: (
      //     <>
      //       <p>自动检测术语</p>
      //       <Popover
      //         content={
      //           <div style={{ maxWidth: '320px' }}>
      //             <p>开启后会自动提取网页中的专业术语，并根据上下文翻译，有效提高翻译质量</p>
      //             <br />
      //             <p>
      //               自动检测术语开启后会自动在「网页对照翻译」、「悬停翻译」中生效。由于需要额外经过
      //               AI 模型解析，所以会略微影响翻译速度
      //             </p>
      //           </div>
      //         }
      //         placement='right'
      //         getPopupContainer={(el) => el.parentElement!}
      //       >
      //         <img
      //           className={styles.warningIcon}
      //           src={commonUtils.getStaticFile('common/icon__warning.png')}
      //         />
      //       </Popover>
      //     </>
      //   ),
      //   description: '支持',
      // },
      // 智能语境
      // {
      //   name: (
      //     <>
      //       <p>智能语境</p>
      //       <Popover
      //         content={
      //           <div style={{ maxWidth: '320px' }}>
      //             <p>
      //               开启后会自动提取网页中的标题、描述、关键词、网页内容等上下文信息，并根据不同的解析模式，通过
      //               AI 模型生成对应的语境解析，有效提高翻译质量
      //             </p>
      //             <br />
      //             <p>
      //               智能语境功能开启后会自动在「网页对照翻译」、「划词翻译」、「悬停翻译」中生效。由于需要额外经过
      //               AI 模型解析，所以会略微影响翻译速度
      //             </p>
      //             <br />
      //             <p>
      //               基础解析：提取标题、描述、关键词。
      //               <strong>解析程度较浅，质量提升一般，速度较快</strong>
      //             </p>
      //             <p>
      //               高级解析：提取标题、描述、关键词、网页内容，并经由 AI 生成 3 个维度的语境解析。
      //               <strong>解析程度适中，质量提升适中，速度适中</strong>。推荐日常使用
      //             </p>
      //             <p>
      //               深度解析：提取标题、描述、关键词、网页内容，并经由 AI 生成 8 个维度的语境解析。
      //               <strong>解析程度较深，质量提升较高，速度较慢</strong>。推荐专业翻译场景使用
      //             </p>
      //           </div>
      //         }
      //         placement='right'
      //         getPopupContainer={(el) => el.parentElement!}
      //       >
      //         <img
      //           className={styles.warningIcon}
      //           src={commonUtils.getStaticFile('common/icon__warning.png')}
      //         />
      //       </Popover>
      //     </>
      //   ),
      //   description: (
      //     <>
      //       <span className={styles.highlightUltra}>深度解析</span>/高级解析/基础解析
      //     </>
      //   ),
      // },
      // 文件批量翻译
      // {
      //   name: (
      //     <>
      //       <p>文件批量翻译</p>
      //       <Popover
      //         content={
      //           <div style={{ maxWidth: '320px' }}>
      //             <p>文件批量翻译支持同时翻译多个文件，可大幅提高翻译效率</p>
      //             <br />
      //             <p>
      //               批量翻译目前仅支持 PDF 无损翻译。后续将尽快支持 PDF 分段翻译、Word
      //               翻译、图片翻译的批量翻译功能，敬请期待
      //             </p>
      //           </div>
      //         }
      //         placement='right'
      //         getPopupContainer={(el) => el.parentElement!}
      //       >
      //         <img
      //           className={styles.warningIcon}
      //           src={commonUtils.getStaticFile('common/icon__warning.png')}
      //         />
      //       </Popover>
      //     </>
      //   ),
      //   description: (
      //     <>
      //       可批量翻译 <span className={styles.highlightUltra}> 100 </span> 个文件
      //     </>
      //   ),
      // },
      // 文件保留时长
      {
        name: (
          <>
            <p>文件保留时长</p>
            <Popover
              content={
                <div style={{ maxWidth: '320px' }}>
                  <p>
                    您上传的文件（包括 PDF、Word
                    等）会被存储在专属的安全服务器中，以方便您随时访问&下载
                  </p>
                  <br />
                  <p>
                    基于存储成本及文件安全考虑，文件在一段时间后将被清理。我们会为更高级会员提供更长的文件保留时长
                  </p>
                </div>
              }
              placement='right'
              getPopupContainer={(el) => el.parentElement!}
            >
              <img
                className={styles.warningIcon}
                src={commonUtils.getStaticFile('common/icon__warning.png')}
              />
            </Popover>
          </>
        ),
        description: (
          <>
            翻译文件及记录保留{' '}
            <span className={styles.highlightUltra}> {UltraConstData.fileRetentionMonth} </span>{' '}
            个月
          </>
        ),
      },
      // 文件解析速度
      {
        name: (
          <>
            <p>文件解析速度</p>
            <Popover
              content={
                <div style={{ maxWidth: '320px' }}>
                  <p>
                    系统需要一定的服务器资源对 PDF 分段翻译、PDF 无损翻译、Word
                    翻译中上传的文件进行解析
                  </p>
                  <br />
                  <p>我们会为更高级会员提供更多的文件解析资源，以提供更快的文件解析速度</p>
                </div>
              }
              placement='right'
              getPopupContainer={(el) => el.parentElement!}
            >
              <img
                className={styles.warningIcon}
                src={commonUtils.getStaticFile('common/icon__warning.png')}
              />
            </Popover>
          </>
        ),
        description: (
          <>
            极速解析｜
            <span className={styles.highlightUltra}>{UltraConstData.fileParseSpeed}页/分钟</span>
          </>
        ),
      },
      // 轻量 AI 功能
      // {
      //   name: (
      //     <>
      //       <p>轻量 AI 功能</p>
      //       <Popover
      //         content={
      //           <div style={{ maxWidth: '320px' }}>
      //             <p>轻量 AI 功能包括 AI Chat、AI 解析、AI 总结</p>
      //           </div>
      //         }
      //         placement='right'
      //         getPopupContainer={(el) => el.parentElement!}
      //       >
      //         <img
      //           className={styles.warningIcon}
      //           src={commonUtils.getStaticFile('common/icon__warning.png')}
      //         />
      //       </Popover>
      //     </>
      //   ),
      //   description: (
      //     <>
      //       <p style={{ textAlign: 'right' }}> 不限次数 </p>
      //       <p>
      //         <span className={styles.highlightUltra}>顶级模型</span>/高级模型/基础模型
      //       </p>
      //     </>
      //   ),
      // },
      // 翻译线路
      {
        name: (
          <>
            <p>翻译线路</p>
            <Popover
              content={
                <div style={{ maxWidth: '300px' }}>
                  <p>系统会根据用户当前会员类型，默认为其应用对应的翻译线路</p>
                  <br />
                  <p>基础线路：满足用户基础使用需求。高峰时段限速</p>
                  <p>
                    高级线路：相较于基础线路，<strong>翻译速度快约 90%</strong>
                    ，高峰时段可能限速
                  </p>
                  <p>
                    优质线路：相较于高级线路，翻译速度略快，
                    <strong>全时段不限速</strong>
                  </p>
                </div>
              }
              placement='right'
              getPopupContainer={(el) => el.parentElement!}
            >
              <img
                className={styles.warningIcon}
                src={commonUtils.getStaticFile('common/icon__warning.png')}
              />
            </Popover>
          </>
        ),
        description: (
          <>
            <p style={{ textAlign: 'right' }}>
              <span className={styles.highlightUltra}>优质线路</span>
            </p>
            <p>全时段不限速</p>
          </>
        ),
      },

      // 发票支持
      { name: '发票支持', description: '2 个工作日内开出' },
      // 7*12h 专属客服支持
      { name: '7*12h 专属客服支持', description: '' },
    ],
  },
  actionButton: {
    text: '立即订阅',
    variant: 'primary',
    onClick: () => console.log('Ultra plan clicked'),
  },
}

// VIP版配置
export const vipPlanConfig: PricingCardProps = {
  planType: 'vip',
  init: false,
  header: {
    planType: 'vip',
    title: 'Max 会员',
    icon: 'price_max.png',
    monthlyPrice: '0',
    annualMonthlyPrice: '34.3',
    annualPrice: '294',
    originalAnnualPrice: '468',
    discountPercent: 37,
    showAnnualToggle: true,
    isAnnualSubscription: false,
    onAnnualToggle: (isAnnual) => console.log('Annual toggle:', isAnnual),
  },
  modelSection: {
    planType: 'vip',
    tokenQuotas: [
      {
        title: (
          <>
            每月
            <span className={styles.highlightMax}>
              {' '}
              {MaxConstData.maxModelToken.toLocaleString()}{' '}
            </span>
            万高级模型 Token
            <Popover
              content={
                <div style={{ maxWidth: '320px' }}>
                  <p>
                    {MaxConstData.maxModelToken.toLocaleString()} 万 Token
                    大约可以处理的翻译任务数量：
                  </p>
                  <p>200 篇中篇小说翻译，</p>
                  <p>或 3,000 页 PDF 文档翻译（论文类型），</p>
                  <p>或 5,000 个常见网页的对照翻译，</p>
                  <p>或 50,000 次的划词翻译</p>
                  <p>注：实际可处理任务数量取决于任务中包含的文本字数，可能大于或小于以上数量</p>
                </div>
              }
              placement='top'
              getPopupContainer={(el) => el.parentElement!}
            >
              <img
                className={styles.warningIcon}
                src={commonUtils.getStaticFile('common/icon__warning.png')}
              />
            </Popover>
          </>
        ),
        description: '使用由高级模型驱动的翻译、总结、解释、Chat 功能。翻译更精准，使用更丝滑。',
        monthlyQuota: '2000W',
        models: advancedModels,
      },
    ],
  },
  featureList: {
    title: 'Max 会员专属 (包含所有免费会员权益)',
    planType: 'vip',
    planDesc: (
      <>
        <span>高级模型搭配充足额度，有效提高工作效率。</span>
        <br />
        <span>适用在日常办公、学习中有翻译需求的用户</span>
      </>
    ),
    planCompare: (
      <>
        <div className={styles.planCompareItem}>
          <span className={styles.label}>翻译质量</span>
          <div className={styles.iconList}>{renderGroupIcon('quality', 4)}</div>
        </div>
        <div className={styles.planCompareItem}>
          <span className={styles.label}>翻译速度</span>
          <div className={styles.iconList}>{renderGroupIcon('speed', 5)}</div>
        </div>
      </>
    ),
    features: [
      // 顶级模型 Token
      {
        name: (
          <>
            <p>顶级模型 Token</p>
            <Popover
              content={
                <div style={{ maxWidth: '320px' }}>
                  <p>顶级模型包括 Claude 4 Sonnet、GPT-5、Gemini 2.5 Pro</p>
                </div>
              }
            >
              <img
                className={styles.warningIcon}
                src={commonUtils.getStaticFile('common/icon__warning.png')}
              />
            </Popover>
          </>
        ),
        description: '不可用',
      },
      // 高级模型 Token
      {
        name: (
          <>
            <p>高级模型 Token</p>
            <Popover
              content={
                <div style={{ maxWidth: '320px' }}>
                  <p>
                    高级模型包括 DeepL、DeepSeek
                    V3、Doubao-Seed-1.6、Qwen-3-Plus、智谱GLM-4.5、GPT-5 mini、Claude 3.5
                    Haiku、Gemini 2.5 Flash
                  </p>
                </div>
              }
            >
              <img
                className={styles.warningIcon}
                src={commonUtils.getStaticFile('common/icon__warning.png')}
              />
            </Popover>
          </>
        ),
        description: (
          <>
            <span className={styles.highlightMax}>
              {' '}
              {MaxConstData.maxModelToken.toLocaleString()} 万/月
            </span>
          </>
        ),
      },
      // 核心翻译功能
      {
        name: (
          <>
            <p>核心翻译功能</p>
            <Popover
              content={
                <div style={{ maxWidth: '320px' }}>
                  <p>
                    核心翻译功能包括：网页译文翻译、网页对照翻译、划词翻译、悬停翻译、视频翻译、即时翻译
                  </p>
                </div>
              }
              placement='right'
              getPopupContainer={(el) => el.parentElement!}
            >
              <img
                className={styles.warningIcon}
                src={commonUtils.getStaticFile('common/icon__warning.png')}
              />
            </Popover>
          </>
        ),
        description: (
          <>
            <p style={{ textAlign: 'right' }}> 不限次数 </p>
            <p>
              <span className={styles.highlightMax}>高级模型</span>/基础模型
            </p>
          </>
        ),
      },
      // PDF 分段翻译
      {
        name: (
          <>
            <a
              className={styles.underlineLink}
              href='https://lenovo.huiyiai.net/pdf_pro'
              target='__blank'
            >
              PDF 分段翻译
            </a>
            <Popover
              content={
                <div style={{ maxWidth: '320px' }}>
                  <p>由 AI 驱动的 PDF 分段翻译</p>
                  <p>支持扫描版 PDF。提供上下对照的分段翻译效果，更利于阅读</p>
                  <p>适用于科研论文、技术文档等专业性较强文档的查阅场景</p>
                </div>
              }
              placement='right'
              getPopupContainer={(el) => el.parentElement!}
            >
              <img
                className={styles.warningIcon}
                src={commonUtils.getStaticFile('common/icon__warning.png')}
              />
            </Popover>
          </>
        ),
        description: (
          <>
            <p style={{ textAlign: 'right' }}>
              <span className={styles.highlightMax}>
                {MaxConstData.pdfProPageCount.toLocaleString()} 页/月
              </span>
            </p>
            <p>
              单个文件最大
              <span className={styles.highlightMax}>
                {MaxConstData.pdfProMaxPage.toLocaleString()}页/
                {MaxConstData.pdfProMaxFileSize.toLocaleString()}M
              </span>
            </p>
          </>
        ),
      },
      // PDF 无损翻译
      // {
      //   name: (
      //     <>
      //       <a
      //         className={styles.underlineLink}
      //         href='https://lenovo.huiyiai.net/pdf_ultra'
      //         target='__blank'
      //       >
      //         PDF 无损翻译
      //       </a>
      //       <Popover
      //         content={
      //           <div style={{ maxWidth: '320px' }}>
      //             <p>由 AI 驱动的 PDF 无损翻译</p>
      //             <p>暂不支持扫描版 PDF。提供 1:1 保留原版式的翻译效果</p>
      //             <p>适用于公司介绍、产品说明书等对版式还原要求较高的翻译场景</p>
      //           </div>
      //         }
      //         placement='right'
      //         getPopupContainer={(el) => el.parentElement!}
      //       >
      //         <img
      //           className={styles.warningIcon}
      //           src={commonUtils.getStaticFile('common/icon__warning.png')}
      //         />
      //       </Popover>
      //     </>
      //   ),
      //   description: (
      //     <>
      //       <p style={{ textAlign: 'right' }}>
      //         <span className={styles.highlightMax}>5,000 页/月</span>
      //       </p>
      //       <p>
      //         单个文件最大<span className={styles.highlightMax}> 500页/100M</span>
      //       </p>
      //     </>
      //   ),
      // },
      // Word 翻译
      // {
      //   name: (
      //     <>
      //       <a className={styles.underlineLink} href='https://lenovo.huiyiai.net/word' target='__blank'>
      //         Word 翻译
      //       </a>
      //       <Popover
      //         content={
      //           <div style={{ maxWidth: '320px' }}>
      //             <p>由 AI 驱动的 Word 翻译</p>
      //             <p>上传待翻译的 Word 文件，翻译完成后自动下载到本地</p>
      //           </div>
      //         }
      //         placement='right'
      //         getPopupContainer={(el) => el.parentElement!}
      //       >
      //         <img
      //           className={styles.warningIcon}
      //           src={commonUtils.getStaticFile('common/icon__warning.png')}
      //         />
      //       </Popover>
      //     </>
      //   ),
      //   description: (
      //     <>
      //       <p style={{ textAlign: 'right' }}>
      //         <span className={styles.highlightMax}>不限页数</span>
      //       </p>
      //       <p>
      //         单个文件最大<span className={styles.highlightMax}> 50M</span>
      //       </p>
      //     </>
      //   ),
      // },
      // 自定义术语表
      // {
      //   name: (
      //     <>
      //       <a
      //         className={styles.underlineLink}
      //         href='https://lenovo.huiyiai.net/dashboard/glossary'
      //         target='__blank'
      //       >
      //         自定义术语表
      //       </a>
      //       <Popover
      //         content={
      //           <div style={{ maxWidth: '320px' }}>
      //             <p>
      //               已支持在 PDF 分段翻译、PDF 无损翻译、Word
      //               翻译、网页对照翻译、划词翻译、悬停翻译、文本翻译、视频翻译中应用术语
      //             </p>
      //           </div>
      //         }
      //         placement='right'
      //         getPopupContainer={(el) => el.parentElement!}
      //       >
      //         <img
      //           className={styles.warningIcon}
      //           src={commonUtils.getStaticFile('common/icon__warning.png')}
      //         />
      //       </Popover>
      //     </>
      //   ),
      //   description: (
      //     <>
      //       <p style={{ textAlign: 'right' }}>
      //         <span className={styles.highlightMax}> 200 </span>条自定义术语
      //       </p>
      //       <p>Trados 术语库｜多设备同步</p>
      //     </>
      //   ),
      // },
      // 网页生词高亮
      {
        name: (
          <>
            <a
              className={styles.underlineLink}
              href='https://lenovo.huiyiai.net/learning?tab=unlearned'
              target='__blank'
            >
              网页生词高亮
            </a>
            <Popover
              content={
                <div style={{ maxWidth: '260px' }}>
                  <p>根据配置的词库，自动识别并高亮网页中的生词及释义，把网页变成“课堂”</p>
                </div>
              }
              placement='right'
              getPopupContainer={(el) => el.parentElement!}
            >
              <img
                className={styles.warningIcon}
                src={commonUtils.getStaticFile('common/icon__warning.png')}
              />
            </Popover>
          </>
        ),
        description: '无限制使用',
      },
      // 图片翻译
      {
        name: '图片翻译',
        description: `${MaxConstData.pictureCount.toLocaleString()} 张/月`,
      },
      // 自动检测术语
      // {
      //   name: (
      //     <>
      //       <p>自动检测术语</p>
      //       <Popover
      //         content={
      //           <div style={{ maxWidth: '320px' }}>
      //             <p>开启后会自动提取网页中的专业术语，并根据上下文翻译，有效提高翻译质量</p>
      //             <br />
      //             <p>
      //               自动检测术语开启后会自动在「网页对照翻译」、「悬停翻译」中生效。由于需要额外经过
      //               AI 模型解析，所以会略微影响翻译速度
      //             </p>
      //           </div>
      //         }
      //         placement='right'
      //         getPopupContainer={(el) => el.parentElement!}
      //       >
      //         <img
      //           className={styles.warningIcon}
      //           src={commonUtils.getStaticFile('common/icon__warning.png')}
      //         />
      //       </Popover>
      //     </>
      //   ),
      //   description: '支持',
      // },
      // 智能语境
      // {
      //   name: (
      //     <>
      //       <p>智能语境</p>
      //       <Popover
      //         content={
      //           <div style={{ maxWidth: '320px' }}>
      //             <p>
      //               开启后会自动提取网页中的标题、描述、关键词、网页内容等上下文信息，并根据不同的解析模式，通过
      //               AI 模型生成对应的语境解析，有效提高翻译质量
      //             </p>
      //             <br />
      //             <p>
      //               智能语境功能开启后会自动在「网页对照翻译」、「划词翻译」、「悬停翻译」中生效。由于需要额外经过
      //               AI 模型解析，所以会略微影响翻译速度
      //             </p>
      //             <br />
      //             <p>
      //               基础解析：提取标题、描述、关键词。
      //               <strong>解析程度较浅，质量提升一般，速度较快</strong>
      //             </p>
      //             <p>
      //               高级解析：提取标题、描述、关键词、网页内容，并经由 AI 生成 3 个维度的语境解析。
      //               <strong>解析程度适中，质量提升适中，速度适中</strong>。推荐日常使用
      //             </p>
      //             <p>
      //               深度解析：提取标题、描述、关键词、网页内容，并经由 AI 生成 8 个维度的语境解析。
      //               <strong>解析程度较深，质量提升较高，速度较慢</strong>。推荐专业翻译场景使用
      //             </p>
      //           </div>
      //         }
      //         placement='right'
      //         getPopupContainer={(el) => el.parentElement!}
      //       >
      //         <img
      //           className={styles.warningIcon}
      //           src={commonUtils.getStaticFile('common/icon__warning.png')}
      //         />
      //       </Popover>
      //     </>
      //   ),
      //   description: (
      //     <>
      //       <span className={styles.highlightMax}>高级解析</span>/基础解析
      //     </>
      //   ),
      // },
      // 文件批量翻译
      // {
      //   name: (
      //     <>
      //       <p>文件批量翻译</p>
      //       <Popover
      //         content={
      //           <div style={{ maxWidth: '320px' }}>
      //             <p>文件批量翻译支持同时翻译多个文件，可大幅提高翻译效率</p>
      //             <br />
      //             <p>
      //               批量翻译目前仅支持 PDF 无损翻译。后续将尽快支持 PDF 分段翻译、Word
      //               翻译、图片翻译的批量翻译功能，敬请期待
      //             </p>
      //           </div>
      //         }
      //         placement='right'
      //         getPopupContainer={(el) => el.parentElement!}
      //       >
      //         <img
      //           className={styles.warningIcon}
      //           src={commonUtils.getStaticFile('common/icon__warning.png')}
      //         />
      //       </Popover>
      //     </>
      //   ),
      //   description: (
      //     <>
      //       可批量翻译 <span className={styles.highlightMax}> 30 </span> 个文件
      //     </>
      //   ),
      // },
      // 文件保留时长
      {
        name: (
          <>
            <p>文件保留时长</p>
            <Popover
              content={
                <div style={{ maxWidth: '320px' }}>
                  <p>
                    您上传的文件（包括 PDF、Word
                    等）会被存储在专属的安全服务器中，以方便您随时访问&下载
                  </p>
                  <br />
                  <p>
                    基于文件安全及存储成本考虑，文件在一段时间后将被清理。我们会为更高级会员提供更长的文件保留时长
                  </p>
                </div>
              }
              placement='right'
              getPopupContainer={(el) => el.parentElement!}
            >
              <img
                className={styles.warningIcon}
                src={commonUtils.getStaticFile('common/icon__warning.png')}
              />
            </Popover>
          </>
        ),
        description: (
          <>
            翻译文件及记录保留{' '}
            <span className={styles.highlightMax}> {MaxConstData.fileRetentionMonth} </span> 个月
          </>
        ),
      },
      // 文件解析速度
      {
        name: (
          <>
            <p>文件解析速度</p>
            <Popover
              content={
                <div style={{ maxWidth: '320px' }}>
                  <p>
                    系统需要一定的服务器资源对 PDF 分段翻译、PDF 无损翻译、Word
                    翻译中上传的文件进行解析
                  </p>
                  <br />
                  <p>我们会为更高级会员提供更多的文件解析资源，以提供更快的文件解析速度</p>
                </div>
              }
              placement='right'
              getPopupContainer={(el) => el.parentElement!}
            >
              <img
                className={styles.warningIcon}
                src={commonUtils.getStaticFile('common/icon__warning.png')}
              />
            </Popover>
          </>
        ),
        description: (
          <>
            高速解析｜
            <span className={styles.highlightMax}>{MaxConstData.fileParseSpeed}页/分钟</span>
          </>
        ),
      },
      // 轻量 AI 功能
      // {
      //   name: (
      //     <>
      //       <p>轻量 AI 功能</p>
      //       <Popover
      //         content={
      //           <div style={{ maxWidth: '320px' }}>
      //             <p>轻量 AI 功能包括 AI Chat、AI 解析、AI 总结</p>
      //           </div>
      //         }
      //         placement='right'
      //         getPopupContainer={(el) => el.parentElement!}
      //       >
      //         <img
      //           className={styles.warningIcon}
      //           src={commonUtils.getStaticFile('common/icon__warning.png')}
      //         />
      //       </Popover>
      //     </>
      //   ),
      //   description: (
      //     <>
      //       <p style={{ textAlign: 'right' }}> 不限次数 </p>
      //       <p>
      //         <span className={styles.highlightMax}>高级模型</span>/基础模型
      //       </p>
      //     </>
      //   ),
      // },
      // 翻译线路
      {
        name: (
          <>
            <p>翻译线路</p>
            <Popover
              content={
                <div style={{ maxWidth: '300px' }}>
                  <p>系统会根据用户当前会员类型，默认为其应用对应的翻译线路</p>
                  <br />
                  <p>基础线路：满足用户基础使用需求。高峰时段限速</p>
                  <p>
                    高级线路：相较于基础线路，<strong>翻译速度快约 90%</strong>
                    ，高峰时段可能限速
                  </p>
                  <p>
                    优质线路：相较于高级线路，翻译速度略快，
                    <strong>全时段不限速</strong>
                  </p>
                </div>
              }
              placement='right'
              getPopupContainer={(el) => el.parentElement!}
            >
              <img
                className={styles.warningIcon}
                src={commonUtils.getStaticFile('common/icon__warning.png')}
              />
            </Popover>
          </>
        ),
        description: (
          <>
            <p style={{ textAlign: 'right' }}>
              <span className={styles.highlightMax}>高级线路</span>
            </p>
            <p>高峰时段可能限速</p>
          </>
        ),
      },

      // 发票支持
      { name: '发票支持', description: '2 个工作日内开出' },
      // 7*12h 专属客服支持
      { name: '7*12h 专属客服支持', description: '' },
    ],
  },
  actionButton: {
    text: '立即订阅',
    variant: 'secondary',
    onClick: () => console.log('Max plan clicked'),
  },
}

// 免费版配置
export const freePlanConfig: PricingCardProps = {
  planType: 'free',
  init: false,
  header: {
    planType: 'free',
    title: '免费会员',
    icon: 'price_free.png',
    monthlyPrice: '0',
    annualMonthlyPrice: '0',
    showAnnualToggle: false,
  },
  modelSection: {
    planType: 'free',
    tokenQuotas: [
      {
        title: '免费使用基础模型',
        description: '',
        monthlyQuota: '无限',
        models: basicModels,
      },
      {
        title: '每日赠送 1 万高级模型 Token',
        description: '使用由高级模型驱动的翻译、总结、解释、Chat 功能。翻译更精准，使用更丝滑。',
        monthlyQuota: '1W',
        dailyQuota: '1W',
        models: advancedModels,
      },
    ],
  },
  featureList: {
    title: '免费会员权益',
    planType: 'free',
    planCompare: (
      <>
        <div className={styles.planCompareItem}>
          <span className={styles.label}>翻译质量</span>
          <div className={styles.iconList}>{renderGroupIcon('quality', 1)}</div>
        </div>
        <div className={styles.planCompareItem}>
          <span className={styles.label}>翻译速度</span>
          <div className={styles.iconList}>{renderGroupIcon('speed', 1)}</div>
        </div>
      </>
    ),
    planDesc: '无障碍地浏览外文网页、视频，满足日常娱乐需求',
    features: [
      { name: '顶级模型 Token', description: '不可用' },
      { name: '高级模型 Token', description: '1 万/天' },
      { name: '网页译文翻译', description: '不限次数' },
      { name: '网页对照翻译', description: '共 15 次' },
      { name: '划词翻译', description: '共 5 次' },
      { name: '悬停翻译', description: '共 5 次' },
      { name: '视频翻译', description: '共 5 次' },
      { name: '即时翻译', description: '共 5 次' },
      { name: 'PDF 分段翻译', description: '5 页/天｜最大 10页/5M' },
      // { name: 'PDF 无损翻译', description: '25 页/天｜最大 10页/5M' },
      // { name: 'Word 翻译', description: '最大 10页/5M' },
      // { name: '自定义术语表', description: '不支持' },
      { name: '网页生词高亮', description: '7 天试用' },
      { name: '图片翻译', description: '共 15 张' },
      // { name: '自动检测术语', description: '不支持' },
      // { name: '智能语境', description: '不支持' },
      // { name: '文件批量翻译', description: '不支持' },
      { name: '文件保留时长', description: '翻译文件及记录免费保留 7 天' },
      { name: '文件解析速度', description: '基础解析｜3页/分钟' },
      // { name: '轻量 AI 功能', description: '不限次数｜基础模型' },
      { name: '翻译线路', description: '基础线路｜高峰时段限速' },
      // { name: '登录设备数', description: '支持 1 台设备同时在线' },
    ],
  },
  actionButton: {
    text: '无需付费',
    variant: 'free',
    onClick: () => console.log('Free plan clicked'),
  },
}

// 功能对比表格数据配置
export const comparisonFeatures: ComparisonFeature[] = [
  {
    id: 'basic-model',
    name: '基础模型',
    description: '满足看懂需求，适用于日常娱乐场景',
    icon: 'price_base.png',
    plans: {
      ultra: '无限使用',
      vip: '无限使用',
      free: '无限使用',
    },
  },
  {
    id: 'advanced-model',
    name: '高级模型',
    description: '翻译精准流畅，适用大多数场景',
    icon: 'price_max_model.png',
    plans: {
      ultra: '5000 万 Token/月',
      vip: '2000 万 Token/月',
      free: '赠送 1 万 Token/天',
    },
  },
  {
    id: 'premium-model',
    name: '顶级模型',
    description: '翻译专业，适用专业翻译需求',
    icon: 'price_ultra_model.png',
    plans: {
      ultra: '200 万 Token/月',
      vip: '/',
      free: '/',
    },
  },
  {
    id: 'pdf-translation',
    name: 'PDF 翻译',
    description: 'PDF 高精度分段翻译',
    icon: 'line-global_Upload.png',
    details: ['PDF上传文件体积', 'PDF最大页数限制'],
    plans: {
      ultra: '3000 页/月｜最大 1500 页/300M PDF',
      vip: '1000 页/月｜最大 500页/100M PDF',
      free: '5 页/天｜最大 10页/5M',
    },
  },
  {
    id: 'chat-pdf',
    name: 'ChatPDF询问次数',
    description: '基于PDF的chat对话中，总共对话次数',
    icon: 'chat_pdf.png',
    plans: {
      ultra: '消耗Token',
      vip: '消耗Token',
      free: '消耗Token',
    },
  },
  {
    id: 'web-translation',
    name: '网页翻译',
    description: '双语对照，划词/悬停快捷翻译',
    icon: 'web_translation_price.png',
    details: ['双语对照翻译', '划词翻译', '悬停翻译'],
    plans: {
      ultra: '消耗Token',
      vip: '消耗Token',
      free: '消耗Token',
    },
  },
  {
    id: 'study-mode',
    name: '学习模式',
    description: '全网页自动高亮生词，把网页变成“课堂”',
    icon: 'study_price.png',
    details: ['生词高亮', '全词库解锁', '单词回顾'],
    plans: {
      ultra: '无限',
      vip: '无限',
      free: '7天免费使用',
    },
  },
  {
    id: 'image-translation',
    name: '图片翻译',
    description: '图片翻译、截图翻译、网页图片翻译全场景覆',
    icon: 'image_translation_price.png',
    details: ['图片文件翻译', '截图翻译', '网页图片翻译'],
    plans: {
      ultra: '2000张/月',
      vip: '1000张/月',
      free: '共15张',
    },
  },

  {
    id: 'search-translation',
    name: '搜索',
    description: '搜索框一键翻译回填，提高搜索效率',
    icon: 'search_price.png',

    plans: {
      ultra: '消耗Token',
      vip: '消耗Token',
      free: '消耗Token',
    },
  },
  {
    id: 'online-translation',
    name: '在线翻译',
    description: '填写词/句，即时翻译浏览器外文本',
    icon: 'online_translation_price.png',
    plans: {
      ultra: '消耗Token',
      vip: '消耗Token',
      free: '消耗Token',
    },
  },
  {
    id: 'video-translation',
    name: '视频翻译',
    description: 'YouTube双语字幕，提升观看体验',
    icon: 'video_translation_price.png',
    plans: {
      ultra: '消耗Token',
      vip: '消耗Token',
      free: '消耗Token',
    },
  },
  {
    id: 'summary-translation',
    name: '总结',
    description: '支持全网页总结、YouTube和bilibili视频总结',
    icon: 'summary_price.png',
    details: ['网页总结', '视频总结'],
    plans: {
      ultra: '消耗Token',
      vip: '消耗Token',
      free: '消耗Token',
    },
  },
  {
    id: 'collect-translation',
    name: '收藏',
    description: '可作为你的私人备忘录，一键收藏总结内容',
    icon: 'collect_price.png',
    plans: {
      ultra: '无限',
      vip: '无限',
      free: '无限',
    },
  },
]

// 计划类型配置
export const comparisonPlans: PlanType[] = ['ultra', 'vip', 'free']

// 功能对比表格默认配置
export const defaultComparisonConfig = {
  title: '功能权益对比',
  features: comparisonFeatures,
  plans: comparisonPlans,
}
